module.exports = __webpack_public_path__ + "img/lb.f1d34347.svg";